"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
exports.LayoutMenuHeader = function (props) {
    var opened = props.opened, onToggled = props.onToggled;
    return (react_1.default.createElement("span", { "aria-hidden": true, className: "layout-menu-nav-button", title: opened ? 'Close' : 'Open', onClick: function () { return onToggled === null || onToggled === void 0 ? void 0 : onToggled(); } },
        react_1.default.createElement(react_2.Icon, { className: "layout-menu-nav-item-icon", iconName: "GlobalNavButton" })));
};
//# sourceMappingURL=LayoutMenuHeader.js.map